import React from 'react';

function Footer() {
    return (
        <footer className="Footer">
          <div className="footerContainer">
            <div className="FooterItems">
              <a href="https://www.instagram.com/inertia.nyc/" target="_blank">
                  <img src={require("./assets/images/instagram.png")} />
              </a>
              {/*<a href="https://www.facebook.com/company/inertia.nyc/" target="_blank">
                  <img src={require("./assets/images/facebook.png")}/>
              </a> */}
              <a href="https://twitter.com/InertiaNyc" target="_blank">
                  <img src={require("./assets/images/twitter.png" )}/>
              </a>
            </div>
            <p className="footerText" style={{textAlign: 'center'}} >Copyright © Inertia 2021</p>
            </div>
        </footer>
    )
}

export default Footer;
